/**
 * @file   : SectionAd.js
 * @author : Amarjeet Lamba (Amarjeet.Lamba@AspiraConnect.com)
 * @date   : 4/15/2019, 4:22:37 PM
 */
import PropTypes from 'prop-types'
import React from 'react'

import Cont, { ALIGN_CENTER } from '../../../external/components/layout/Cont'
import Section from '../../../external/components/layout/Section'
import { isEmpty } from '../../../external/utilities/GeneralUtils'
import { getAdConfig } from '../../../utilities/ConfigUtils'
import Advert from '../../shared/ad/Advert'
import { isData } from '../InfoUtil'

const SectionAd = ({ section, mainConfig }) => {
  if (section.ad.showAd && isData(section.ad.adId) && !isEmpty(mainConfig)) {
    return (
      <Cont align={ALIGN_CENTER}>
        <Section />
        <Advert id={section.ad.adId} adConfig={getAdConfig(mainConfig)} />
      </Cont>
    )
  }

  return null
}

SectionAd.propTypes = {
  section: PropTypes.object,
  mainConfig: PropTypes.object,
}

export default SectionAd
